import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      certificates: [
        // This array should be aligned with the visitor trust center side
        { label: 'CCPA', value: 'CCPA', url: 'certificates/CCPA.jpg' },
        { label: 'CDSA', value: 'CDSA', url: 'certificates/CDSA.jpg' },
        {
          label: '23 NYCRR Part 500',
          value: '23 NYCRR 500',
          url: 'certificates/23-NYCRR-Part-500.jpg',
        },
        {
          label: 'Center for Internet Security (CIS) benchmarks',
          value: 'CIS Benchmarks',
          url: 'certificates/CIS.jpg',
        },
        {
          label: 'Center for Internet Security (CIS) benchmarks: Level 1',
          value: 'CIS : Level 1',
          url: 'certificates/CISLVL1.jpg',
        },
        {
          label: 'Center for Internet Security (CIS) benchmarks: Level 2',
          value: 'CIS : Level 2',
          url: 'certificates/CISLVL2.jpg',
        },
        {
          label: 'Center for Internet Security (CIS) benchmarks: Level 3',
          value: 'CIS : Level 3',
          url: 'certificates/CISLVL3.jpg',
        },
        {
          label: 'CNSSI 1253',
          value: 'CNSSI 1253',
          url: 'certificates/CNSS.jpg',
        },
        {
          label: 'COBIT 5',
          value: 'COBIT 5',
          url: 'certificates/COBIT.jpg',
        },
        {
          label: 'COBIT 5 Foundation',
          value: 'COBIT 5 Found',
          url: 'certificates/COBITFOUNDATION.jpg',
        },
        {
          label: 'COBIT 5 Implementation',
          value: 'COBIT 5 Implem',
          url: 'certificates/COBITIMPLEMENTATION.jpg',
        },
        {
          label: 'COBIT 5 Assessor',
          value: 'COBIT 5 Assess',
          url: 'certificates/COBITASSESSOR.jpg',
        },
        {
          label: 'COBIT 2019 Foundation',
          value: 'COBIT 2019 Foun',
          url: 'certificates/COBIT2019FOUNDATION.jpg',
        },
        {
          label: 'Cloud Security Alliance (CSA) STAR',
          value: 'CSA STAR',
          url: 'certificates/CSA.jpg',
        },
        {
          label: 'Cloud Security Alliance (CSA) STAR: Level 1: Self-assessment',
          value: 'CSA STAR: Level 1',
          url: 'certificates/CSALVL1.jpg',
        },
        {
          label:
            'Cloud Security Alliance (CSA) STAR: Level 2: Third-party certification',
          value: 'CSA STAR: Level 2',
          url: 'certificates/CSALVL2.jpg',
        },
        {
          label: 'Cyber Essentials:Basic Self-Assessment',
          value: 'Cyber Essen: Bsic',
          url: 'certificates/CYBER-ESSENTIALS.jpg',
        },
        {
          label: 'Cyber Essentials Plus:Third-Party Assessment',
          value: 'Cyber Essen: Plus',
          url: 'certificates/CYBER-ESSENTIALS-PLUS.jpg',
        },
        {
          label: 'FIPS 140-2',
          value: 'FIPS 140-2',
          url: 'certificates/FIPS-140-2.jpg',
        },
        {
          label: 'FIPS 140-2 Level 1',
          value: 'FIPS 140-2: Level 1',
          url: 'certificates/FIPS-140-2LVL1.jpg',
        },
        {
          label: 'FIPS 140-2 Level 2',
          value: 'FIPS 140-2: Level 2',
          url: 'certificates/FIPS-140-2LVL2.jpg',
        },
        {
          label: 'FIPS 140-2 Level 3',
          value: 'FIPS 140-2: Level 3',
          url: 'certificates/FIPS-140-2LVL3.jpg',
        },
        {
          label: 'FIPS 140-2 Level 4',
          value: 'FIPS 140-2: Level 4',
          url: 'certificates/FIPS-140-2LVL4.jpg',
        },
        {
          label: 'CyberGRX',
          value: 'CyberGRX',
          url: 'certificates/CyberGRX.jpg',
        },
        {
          label: 'DFARS',
          value: 'DFARS',
          url: 'certificates/DFARS.jpg',
        },
        {
          label: 'DORA',
          value: 'DORA',
          url: 'certificates/DORA.jpg',
        },
        {
          label: 'DPP',
          value: 'DPP',
          url: 'certificates/DPP.jpg',
        },
        {
          label: 'European Banking Authority (EBA)',
          value: 'EBA',
          url: 'certificates/EBA.jpg',
        },
        {
          label: 'ePrivacy EU',
          value: 'ePrivacy-EU',
          url: 'certificates/ePrivacy.jpg',
        },
        {
          label: 'ePrivacy Global',
          value: 'ePrivacy-Global',
          url: 'certificates/ePrivacy-Global.jpg',
        },
        {
          label: 'ePrivacyApp',
          value: 'ePrivacy-App',
          url: 'certificates/ePrivacy-App.jpg',
        },
        {
          label: 'Electronic Prescriptions for Controlled Substances (EPCS)',
          value: 'EPCS',
          url: 'certificates/EPCS.jpg',
        },
        {
          label: 'EU-US DPF (Privacy Shield)',
          value: 'EU-US DPF',
          url: 'certificates/EU-US-DPF.jpg',
        },
        {
          label: 'EU AI Act',
          value: 'EU AI Act',
          url: 'certificates/EU.jpg',
        },
        {
          label: 'Food and Drug Administration CFR Title 21 Part 11',
          value: '21 CFR Part 11',
          url: 'certificates/FDA.jpg',
        },
        {
          label: 'FERPA',
          value: 'FERPA',
          url: 'certificates/FERPA.jpg',
        },
        {
          label: 'Federal Financial Institutions Examination Council (FFIEC)',
          value: 'FFIEC',
          url: 'certificates/FFIEC.jpg',
        },

        {
          label: 'FISMA',
          value: 'FISMA',
          url: 'certificates/FISMA.jpg',
        },
        {
          label: 'FedRAMP',
          value: 'FedRAMP',
          url: 'certificates/FR.jpg',
        },
        {
          label: 'FedRAMP Impact Level: Low',
          value: 'FedRAMP: Low',
          url: 'certificates/FRLOW.jpg',
        },
        {
          label: 'FedRAMP Impact Level: Moderate',
          value: 'FedRAMP: Moderate',
          url: 'certificates/FRMOD.jpg',
        },
        {
          label: 'FedRAMP Impact Level: High',
          value: 'FedRAMP: High',
          url: 'certificates/FRHIGH.jpg',
        },
        {
          label: 'GDPR',
          value: 'GDPR',
          url: 'certificates/GDPR.jpg',
        },
        {
          label: 'GxP',
          value: 'GXP',
          url: 'certificates/GXP.jpg',
        },

        {
          label: 'HIPAA',
          value: 'HIPAA',
          url: 'certificates/HIPAA.jpg',
        },
        {
          label: 'HECVAT:FULL',
          value: 'HECVAT: FULL',
          url: 'certificates/HECVAT-FULL-v4.1.6.png',
        },
        {
          label: 'HECVAT',
          value: 'HECVAT',
          url: 'certificates/HECVAT.jpg',
        },
        {
          label: 'HECVAT:LITE',
          value: 'HECVAT: LITE',
          url: 'certificates/HECVAT-LITE.jpg',
        },
        {
          label: 'HECVAT:On-Prem',
          value: 'HECVAT: On-Prem',
          url: 'certificates/HECVAT-ONPREM.jpg',
        },
        {
          label: 'HITRUST CSF',
          value: 'HITRUST CSF',
          url: 'certificates/HITRUST.jpg',
        },
        {
          label: 'HITRUST CSF:Validated Assessment',
          value: 'HITRUST CSF: VA',
          url: 'certificates/HITRUST-VALIDATED.jpg',
        },
        {
          label: 'HITRUST CSF:Self-Assessment',
          value: 'HITRUST CSF: SA',
          url: 'certificates/HITRUST-SELF.jpg',
        },
        {
          label: 'HDS',
          value: 'HDS',
          url: 'certificates/HDS.png',
        },
        {
          label: 'ISO 22301:2019',
          value: 'ISO 22301',
          url: 'certificates/ISO223_.png',
        },
        {
          label: 'ISO 27032',
          value: 'ISO 27032',
          url: 'certificates/ISO27032.png',
        },
        {
          label: 'ISO 27035',
          value: 'ISO 27035',
          url: 'certificates/ISO27035.png',
        },

        {
          label: 'EU Data Act',
          value: 'EU Data Act',
          url: 'certificates/e-data-act.jpg',
        },

        {
          label: 'ISO 27701',
          value: 'ISO 27701',
          url: 'certificates/ISO277.png',
        },
        {
          label: 'ISO 14001',
          value: 'ISO 14001',
          url: 'certificates/ISO14001.png',
        },

        {
          label: 'ISO 17024',
          value: 'ISO 17024',
          url: 'certificates/ISO17024.png',
        },
        {
          label: 'ISO 28000',
          value: 'ISO 28000',
          url: 'certificates/ISO28000.png',
        },
        {
          label: 'ISO 42001',
          value: 'ISO 42001',
          url: 'certificates/ISO420.png',
        },
        {
          label: 'ISO 20000',
          value: 'ISO 20000',
          url: 'certificates/ISO2000.png',
        },
        {
          label: 'ISO 9001',
          value: 'ISO 9001',
          url: 'certificates/ISO9001.png',
        },
        {
          label: 'ISO 27001:2022',
          value: 'ISO 27001:2022',
          url: 'certificates/ISO27001.png',
        },
        {
          label: 'ISO 27001',
          value: 'ISO 27001',
          url: 'certificates/ISO27001.png',
        },
        {
          label: 'ISO 27001 by TÜV NORD',
          value: 'ISO 27001 TÜV NORD',
          url: 'certificates/ISO27001TUVNORD.png',
        },
        {
          label: 'ISO 27017',
          value: 'ISO 27017',
          url: 'certificates/ISO27017.png',
        },
        {
          label: 'ISO 27018',
          value: 'ISO 27018',
          url: 'certificates/ISO27018.png',
        },
        {
          label: 'ITAR',
          value: 'ITAR',
          url: 'certificates/ITAR.jpg',
        },
        {
          label: 'NDAA',
          value: 'NDAA',
          url: 'certificates/NDAA.jpg',
        },
        {
          label: 'NERC',
          value: 'NERC',
          url: 'certificates/NERC.jpg',
        },
        {
          label: 'NIS 2',
          value: 'NIS 2',
          url: 'certificates/NIS2.jpg',
        },
        {
          label: 'NIST SP 800-161',
          value: 'NIST SP 800-161',
          url: 'certificates/NIST.jpg',
        },
        {
          label: 'NIST CSF',
          value: 'NIST CSF',
          url: 'certificates/NIST2.jpg',
        },
        {
          label: 'NIST 800-53',
          value: 'NIST 800-53',
          url: 'certificates/NIST53.jpg',
        },
        {
          label: 'National Information Assurance Partnership',
          value: 'NIAP',
          url: 'certificates/NIAP2.jpg',
        },
        {
          label: 'NIST 800-171',
          value: 'NIST 800-171',
          url: 'certificates/NIST171.jpg',
        },
        {
          label: '23 NYCRR 500',
          value: 'NYCRR',
          url: 'certificates/NYCRR.jpg',
        },
        {
          label: 'PCI DSS 4.0.1',
          value: 'PCI-DSS',
          url: 'certificates/PCI.jpg',
        },
        {
          label: 'Privacy Shield',
          value: 'PrivacyShield',
          url: 'certificates/PrivacyShield.png',
        },
        {
          label: 'PIPEDA',
          value: 'PIPEDA',
          url: 'certificates/PIPEDA.jpg',
        },
        {
          label: 'SEC Cybersecurity Disclosure Rule',
          value: 'SEC Cyber Dis Rl',
          url: 'certificates/SEC.jpg',
        },
        {
          label: 'SOC 1',
          value: 'SOC1',
          url: 'certificates/SOC1.jpg',
        },
        {
          label: 'SOC 1 Type I',
          value: 'SOC 1: Type 1',
          url: 'certificates/SOC1TYPE1.jpg',
        },
        {
          label: 'SOC 1 Type II',
          value: 'SOC 1: Type 2',
          url: 'certificates/SOC1TYPE2.jpg',
        },
        {
          label: 'SOC 2',
          value: 'SOC2',
          url: 'certificates/SOC2.jpg',
        },
        {
          label: 'SOC 2 Type I',
          value: 'SOC 2: Type 1',
          url: 'certificates/SOC2TYPE1.jpg',
        },
        {
          label: 'SOC 2 Type II',
          value: 'SOC 2: Type 2',
          url: 'certificates/SOC2TYPE2.jpg',
        },
        {
          label: 'SOC 3',
          value: 'SOC 3',
          url: 'certificates/SOC3.jpg',
        },
        {
          label: 'SOX',
          value: 'SOX',
          url: 'certificates/SOX.jpg',
        },
        {
          label: 'TISAX AL 1',
          value: 'TISAX: AL1',
          url: 'certificates/TISAXAL1.jpg',
        },
        {
          label: 'TISAX AL 2',
          value: 'TISAX: AL2',
          url: 'certificates/TISAXAL2.jpg',
        },
        {
          label: 'TISAX AL 3',
          value: 'TISAX: AL3',
          url: 'certificates/TISAXAL3.jpg',
        },
        {
          label: 'TISAX',
          value: 'TISAX',
          url: 'certificates/TISAX.jpg',
        },
        {
          label: 'TRUSTe',
          value: 'TRUSTe',
          url: 'certificates/TRUSTE.jpg',
        },
        {
          label: 'TX-RAMP',
          value: 'TX-RAMP',
          url: 'certificates/TX-RAMP.jpg',
        },
        {
          label: 'TX-RAMP Level 1',
          value: 'TX-RAMP: Level 1',
          url: 'certificates/TX-RAMP-L1.jpg',
        },
        {
          label: 'TX-RAMP Level 2',
          value: 'TX-RAMP: Level 2',
          url: 'certificates/TX-RAMP-L2.jpg',
        },
        {
          label: 'VCDPA',
          value: 'VCDPA',
          url: 'certificates/VCDPA.jpg',
        },

        {
          label: 'WCAG',
          value: 'WCAG',
          url: 'certificates/WCAG.jpg',
        },
        {
          label: 'SecNumCloud',
          value: 'SecNumCloud',
          url: 'certificates/SecNumCloud.jpg',
        },
        {
          label: 'ISMAP',
          value: 'ISMAP',
          url: 'certificates/ISMAP.jpg',
        },
        {
          label: 'The Israeli Privacy Protection Law',
          value: 'Israeli Priv Prot Law',
          url: 'certificates/IsraeliPrivProtLaw.jpg',
        },
        {
          label: 'CyDR',
          value: 'CyDR',
          url: 'certificates/CyDR.png',
        },
        {
          label: 'GovRAMP',
          value: 'GovRAMP',
          url: 'certificates/GovRAMP.png',
        },
        {
          label: 'VPAT',
          value: 'VPAT',
          url: 'certificates/VPAT.png',
        },
        {
          label: 'ISO 27001 SoA',
          value: 'ISO 27001 SoA',
          url: 'certificates/ISO27001SoA.png',
        },
        {
          label: 'ISO 45001',
          value: 'ISO 45001',
          url: 'certificates/ISO45001.png',
        },
        {
          label: 'IEC 62443',
          value: 'IEC 62443',
          url: 'certificates/IEC62443.png',
        },
        {
          label: 'ENS',
          value: 'ENS',
          url: 'certificates/ENS.png',
        },
        {
          label: 'ANATEL',
          value: 'ANATEL',
          url: 'certificates/ANATEL.png',
        },
        {
          label: 'ACN',
          value: 'ACN',
          url: 'certificates/ACN.png',
        },
        {
          label: 'FSQS',
          value: 'FSQS',
          url: 'certificates/FSQS.png',
        },
        {
          label: 'PCI DSS Level 1',
          value: 'PCI DSS: Level 1',
          url: 'certificates/PCIDSSL1.png',
        },
        {
          label: 'PCI DSS Level 2',
          value: 'PCI DSS: Level 2',
          url: 'certificates/PCIDSSL2.png',
        },
        {
          label: 'PCI DSS Level 3',
          value: 'PCI DSS: Level 3',
          url: 'certificates/PCIDSSL3.png',
        },
        {
          label: 'PCI DSS Level 4',
          value: 'PCI DSS: Level 4',
          url: 'certificates/PCIDSSL4.png',
        },
        {
          label: 'PCI PIN',
          value: 'PCI PIN',
          url: 'certificates/PCIPIN.png',
        },
        {
          label: 'PCI PTS POI',
          value: 'PCI PTS POI',
          url: 'certificates/PCIPTSPOI.png',
        },
        {
          label: 'PCI MPoC',
          value: 'PCI MPoC',
          url: 'certificates/PCIMPoC.png',
        },
        {
          label: 'PCI 3DS',
          value: 'PCI 3DS',
          url: 'certificates/PCI3DS.png',
        },
        {
          label: 'PCI P2PE',
          value: 'PCI P2PE',
          url: 'certificates/PCIP2PE.png',
        },
        {
          label: 'PCI Card Production',
          value: 'PCI Card Production',
          url: 'certificates/PCICardProduction.png',
        },
        {
          label: 'PCI SSF',
          value: 'PCI SSF',
          url: 'certificates/PCISSF.png',
        },
        {
          label: 'PCI Secure Software Standard',
          value: 'PCI Secure Software',
          url: 'certificates/PCISecureSoftwareStandard.png',
        },
        {
          label: 'PCI Secure SLC',
          value: 'PCI Secure SLC',
          url: 'certificates/PCISecureSLC.png',
        },
        {
          label: 'PCI PA-DSS',
          value: 'PCI PA-DSS',
          url: 'certificates/PCIPADSS.png',
        },
        {
          label: 'SI ISO 27701:2019 (Israel)',
          value: 'SI ISO 27701:2019',
          url: 'certificates/SI_ISO27701_2019_SII.png',
        },
        {
          label: 'SI ISO 27001:2022 (Israel)',
          value: 'SI ISO 27001:2022',
          url: 'certificates/SI_ISO27001_2022_SII.png',
        },
        {
          label: 'SI ISO 27017:2015 (Israel)',
          value: 'SI ISO 27017:2015',
          url: 'certificates/SI_ISO27017_2015_SII.png',
        },
        {
          label: 'ISO 27001 by Schellman',
          value: 'ISO 27001 Schellman',
          url: 'certificates/ISO27001SCHELLMAN.png',
        },
        {
          label: 'ISO 27701 by Schellman',
          value: 'ISO 27701 Schellman',
          url: 'certificates/ISO27701SCHELLMAN.png',
        },
        {
          label: 'ISO 42001 by Schellman',
          value: 'ISO 42001 Schellman',
          url: 'certificates/ISO42001SCHELLMAN.png',
        },
        { label: 'C5 (BSI, Germany)', value: 'C5', url: 'certificates/C5.png' },
        {
          label: 'IRAP (Australia)',
          value: 'IRAP',
          url: 'certificates/IRAP.png',
        },
        { label: 'CMMC (US DoD)', value: 'CMMC', url: 'certificates/CMMC.png' },
        {
          label: 'EU Cloud Code of Conduct',
          value: 'EU Cloud Code of Conduct',
          url: 'certificates/EU-CLOUD-CODE-OF-CONDUCT.png',
        },
        {
          label: 'FedRAMP 20x',
          value: 'FedRAMP 20x',
          url: 'certificates/FEDRAMP-20X.png',
        },
        {
          label: 'APEC CBPR / PRP',
          value: 'APEC CBPR-PRP',
          url: 'certificates/APEC-CBPR-PRP.png',
        },
        { label: 'AIUC-1', value: 'AIUC-1', url: 'certificates/AIUC-1.png' },
        {
          label: 'NIST AI RMF',
          value: 'NIST AI RMF',
          url: 'certificates/NIST-AI-RMF.png',
        },
        {
          label: 'NIST 800-218 (SSDF)',
          value: 'NIST 800-218',
          url: 'certificates/NIST-800-218.png',
        },
        { label: 'LGPD (Brazil)', value: 'LGPD', url: 'certificates/LGPD.png' },
        { label: 'GLBA', value: 'GLBA', url: 'certificates/GLBA.png' },
        {
          label: 'APRA CPS 234',
          value: 'APRA CPS 234',
          url: 'certificates/APRA-CPS-234.png',
        },
        {
          label: 'Essential 8 (ACSC)',
          value: 'Essential 8',
          url: 'certificates/ESSENTIAL-8.png',
        },
        {
          label: 'Common Criteria (ISO 15408)',
          value: 'Common Criteria',
          url: 'certificates/COMMON-CRITERIA.png',
        },
        {
          label: 'ISAE 3000 Type II',
          value: 'ISAE 3000 Type II',
          url: 'certificates/ISAE-3000-TYPE-II.png',
        },
        { label: 'UK GDPR', value: 'UK GDPR', url: 'certificates/UK-GDPR.png' },
        {
          label: 'Swiss-US DPF + UK Extension',
          value: 'Swiss-US DPF',
          url: 'certificates/SWISS-US-DPF.png',
        },
        {
          label: 'CISA Secure by Design Pledge',
          value: 'CISA Secure by Design',
          url: 'certificates/CISA-SECURE-BY-DESIGN.png',
        },
        {
          label: 'TRUSTe Responsible AI',
          value: 'TRUSTe Responsible AI',
          url: 'certificates/TRUSTE-RESPONSIBLE-AI.png',
        },
        {
          label: 'CASA (App Defense Alliance)',
          value: 'CASA',
          url: 'certificates/CASA.png',
        },
      ],
    }
  },
  computed: {
    ...mapGetters([
      'GET_TRUST_CENTER_SHARES_DB',
      'GET_TRUST_CENTER_DB',
      'GET_CURRENT_USER',
    ]),
    accessControl() {
      return (
        this.GET_TRUST_CENTER_DB.find((i) => i.type === 'accessControl') ?? {}
      )
    },
    astLeastOneDocumentDownloadable() {
      return this.GET_TRUST_CENTER_DB.some((doc) => {
        if (doc.type === 'document') {
          return this.canBeDownloaded(doc) === true
        }
        return false
      })
    },
    isNdaApproved() {
      let nda = Array.isArray(this.GET_TRUST_CENTER_SHARES_DB)
        ? this.GET_TRUST_CENTER_SHARES_DB.find(
            (i) => i.type === 'nda' && i.tcVisitorTid !== 'anonymous' // Not for anonymous visitors
          )
        : {}

      console.log(
        'Inside isNdaApproved - nda, this.GET_TRUST_CENTER_SHARES_DB',
        nda,
        this.GET_TRUST_CENTER_SHARES_DB
      )
      return nda && nda.state === 'approved'
    },
  },
  methods: {
    canBeDownloaded(doc) {
      //v-if="doc.access === 'public' || (doc.access === 'nda' && isNdaApproved)"

      const accessScope = this.accessControl?.accessScope
      console.log(
        'Inside canBeDownloaded - doc, accessScope',
        _.cloneDeep(doc),
        accessScope
      )
      const autoApprove = _.get(this.accessControl, 'autoApprove')
      let res = false
      if (doc.access === 'public') {
        res = true
      } else if (doc.access === 'nda' && this.isNdaApproved) {
        // Only NDA requested
        res = true
      } else if (
        doc.access === 'manual' &&
        ((doc.requestNDA && this.isNdaApproved) || doc.requestNDA === false) &&
        autoApprove
      ) {
        //Manual can be request NDA or not
        // Check if the email is allowed
        res = true
      } else if (
        doc.access === 'manual' &&
        ((doc.requestNDA && this.isNdaApproved) || doc.requestNDA === false) &&
        !autoApprove
      ) {
        let manuals = this.GET_TRUST_CENTER_SHARES_DB.filter(
          (i) => i.type === 'manual'
        )

        // Check if document is approved in any manual
        // For user-specific access, also verify requestedByUid matches current user
        res = manuals.some((manual) => {
          if (manual.docs && manual.docs[doc.vdId]) {
            const docEntry = manual.docs[doc.vdId]
            const isApproved = _.get(docEntry, 'state') === 'approved'
            const isNotExpired = !docEntry.expiresAt || docEntry.expiresAt > Date.now()

            if (accessScope === 'user') {
              const requestedByUid = _.get(docEntry, 'requestedByUid')
              return isApproved && isNotExpired && requestedByUid === this.GET_CURRENT_USER?.uid
            }

            return isApproved && isNotExpired
          }
          return false
        })

        console.log(
          'Inside canBeDownloaded - doc, doc.vendorDocName, res',
          _.cloneDeep(doc),
          doc.vendorDocName,
          res
        )
      }

      return res
    },

    getCertificateByValue(certificateValue) {
      return this.certificates.find(
        (certificate) => certificate.value === certificateValue
      )
    },
  },
}
